import { Button, styled } from '@mui/material';

const ActionButton = styled(Button)({
  flex: 1,
  height: '40px',
  fontWeight: 600,
  boxShadow: 'none',
});

export default ActionButton;
